import { format } from 'date-fns'
import { FarmDto } from '../dtos/Farm.dto'
import { GeoImageTypeEnum } from '../enums/GeoImageType.enum'

export class GeoImage {
	isCheckedToDelete: unknown

	constructor(
		readonly name: string,
		readonly farm: FarmDto,
		readonly acquisitionDate: Date,
		readonly imageType: GeoImageTypeEnum,
		readonly fileName: string,
		readonly pixel: string,
		readonly bands: Record<string, string>,
		readonly description?: string,
		readonly code?: number,
		readonly id?: string,
		readonly image?: File,
		readonly bandsCount?: number,
		readonly imageGeometry?: object,
	) {}

	get formattedAcquisitionDate(): string {
		return format(this.acquisitionDate, 'dd/MM/yyyy')
	}

	get imageLink(): string {
		const customerId = localStorage.getItem('customerId')

		return `${process.env.VUE_APP_STORAGE_BASE_URL}/imagens-para-processamento/${customerId}/${this.fileName}`
	}

	get pixelLabel(): string {
		return `${this.pixel} m`
	}
}
